import React from 'react';
import DetailPage from './DetailPage';

const DetailPageAppleIntelligenceReview = () => {
  return (
    <DetailPage 
      title="Apple Intelligence: Review Summarization"
      heroSrc={'/images/apple-intelligence-review-summarization/hero.png'}
      content="Apple Intelligence brings powerful AI capabilities to help users make better decisions. The Review Summarization feature uses advanced natural language processing to analyze thousands of user reviews and distill them into concise, actionable insights. By understanding sentiment, key themes, and common concerns, this feature helps users quickly grasp what matters most about apps, products, and services. It's designed to save time while providing the depth of information needed to make informed choices, all while maintaining privacy and on-device processing where possible."
      year="2025"
      duration="2024 – 2025"
      role="Prototyping Lead"
    >
    </DetailPage>
  );
};

export default DetailPageAppleIntelligenceReview;

